import axios from 'axios';
import orderby from 'lodash/orderBy';
import {initCustomSelects} from './customSelect';

let eventsInfo;
let events;
let filteredEvents;
let sortedEvents;
let featuredPost;
let selectedYear;
let selectedMonth;
let selectedLocation = '';
let selectedEventType = '';
let matchingMonthIndex;
let eventListSection =  null;
let listTotal = 0;
const iconColors = {
    'book':'#d6182e',
    'candle':'#f29d06',
    'educate':'#f29d06',
    'family':'#5ed3b4',
    'film':'#006f53',
    'jewishstar':'#006faa',
    'mic':'#68475d',
    'music':'#e55f33',
    'star':'#00b9e8'
};
const monthNames = {
    '01' : 'January',
    '02' : 'February',
    '03' : 'March',
    '04' : 'April',
    '05' : 'May',
    '06' : 'June',
    '07' : 'July',
    '08' : 'August',
    '09' : 'September',
    '10' : 'October',
    '11' : 'November',
    '12' : 'December',
}


// Initialize filter sections
const eventFiltersSections = document.querySelectorAll('[data-events-filters]');
if(eventFiltersSections.length > 0){

    // load event data from endpoint
    // loadEndpointEvents();

    // loop through filter sections
    eventFiltersSections.forEach((section)=>{

        // set section to loading
        // section.classList.add('block--loading');

        // setup section filter toggle buttons click event
        const toggle = section.querySelector('.post-filters__toggle');
        if(toggle){
            toggle.addEventListener('click',event=>{
                section.classList.toggle('post-filters--visible');
            });
        }

    });

    // get event data from local variable
    getEventsData();

    // setup sections prev buttons click event
    setEventNavButtons();
}


function setEventNavButtons() {
    const filterSection = document.querySelector('[data-events-filters]');
    const navButtons = document.querySelectorAll('[data-nav-button]');
    if(navButtons.length > 0 && filterSection){
        navButtons.forEach(button => {
            button.addEventListener('click',event=>{
                event.preventDefault();
                if(button.dataset.nav =='prev'){
                    matchingMonthIndex += 1;
                }
                if(button.dataset.nav =='next'){
                    matchingMonthIndex -= 1;
                }
                setSectionDate(filterSection);
            });
        });
    }
}


function getEventsData(){
    eventsInfo = allEvents.info;
    events = allEvents.posts;
    populateEventFiltersSections(allEvents);
    if(eventListSection){
        eventListSection.classList.remove('block--loading');
    }    
}


function loadEndpointEvents(){
    axios({
        method: 'get',
        url: siteUrl + '/wp-json/endpoints/events'
    })
    .then(function (response) {
        eventsInfo = response.data.info;
        events = response.data.posts;
        populateEventFiltersSections(response.data);
        if(eventListSection){
            eventListSection.classList.remove('block--loading');
        }
    })
    .catch(function (error) {
        console.log('error: ' + JSON.stringify(error));
    });   
}


function populateEventFiltersSections(data){

    eventFiltersSections.forEach((section)=>{
        selectedYear = section.dataset.year;
        selectedMonth = section.dataset.month;
        selectedLocation = section.dataset.location;
        selectedEventType = section.dataset.eventType;
        setMatchingMonthIndex();
        setSectionDate(section);
        section.classList.remove('block--loading');
    });
}

function getCurrentMonthEvents(){
    const startDate = `${selectedYear}${String(selectedMonth).padStart(2, '0')}01`;
    const endDate = `${selectedYear}${String(selectedMonth).padStart(2, '0')}31`;      
    return events.filter(event => {
        return event.event_date >= startDate && event.event_date <= endDate;
    });    
}

function getFilterSettings() {
    const eventTypesSet = new Set();
    const locationsSet = new Set();
    // process all events in a single loop
    getCurrentMonthEvents().forEach(event => {
        if (event.event_types) {
            event.event_types.split(',').forEach(type => eventTypesSet.add(type));
        }
        if (event.location) {
            event.location.split(',').forEach(location => locationsSet.add(location));
        }
    });
    // get locations options in the same order as they appear on the allEventLocations array
    const orderedLocations = Object.entries(allEventLocations)
        .filter(([key, value]) => locationsSet.has(value))
        .map(([key, value]) => ({ value: key, label: value }));
    // Get event types options in the same order as returned by get_terms()
    const orderedTypes = allEventTypes
        .filter(term => eventTypesSet.has(term.slug))
        .map(term => ({ value: term.slug, label: term.name }));
    // return options
    return {
        locations: orderedLocations,
        eventTypes: orderedTypes,
    };
}



function setMatchingMonthIndex(){
    // find the index of the month matching the selected year and month
    matchingMonthIndex = eventsInfo.months.findIndex( item =>{
        return item.year == selectedYear && item.month == selectedMonth;
    });
    // if no month match set index to first
    if(matchingMonthIndex == -1){
        matchingMonthIndex = 0;
    }
}


function setSectionDate(section){
        // get section date element
        const dateElement = section.querySelector('.post-filters__month');        
        // if we have element and a match, update element html
        if( dateElement && matchingMonthIndex > -1){
            dateElement.innerHTML = eventsInfo.months[matchingMonthIndex]['label'];
            section.dataset.year = eventsInfo.months[matchingMonthIndex]['year'];
            section.dataset.month = eventsInfo.months[matchingMonthIndex]['month'];
            selectedYear = section.dataset.year;
            selectedMonth = section.dataset.month;
        }
        // setup the next and previous buttons
        setPrevNextButtons();
        // update events list
        updateEventsList(section);
        // manage the filter select options
        setFilterOptions();
}


function setPrevNextButtons() {
    const buttons = [
        { type: 'prev', index: matchingMonthIndex + 1 },
        { type: 'next', index: matchingMonthIndex - 1 }
    ];
    buttons.forEach(({ type, index }) => {
        const buttons = document.querySelectorAll(`[data-nav="${type}"]`);
        if (buttons) {
            buttons.forEach(button=>{
                if (index in eventsInfo.months) {
                    button.dataset.index = index;
                    button.classList.remove('disabled');
                } else {
                    button.classList.add('disabled');
                }                
            });
        }
    });
}


function updateEventsList(section){
    filterEvents();
    printEvents();
    setSectionUrlParameters(section);
}

function setFilterOptions(){
    
    const filterSettings = getFilterSettings();
    const locationSelectWrapper = document.querySelector('[data-filter-select="location"]');
    const typeSelectWrapper = document.querySelector('[data-filter-select="event_type"]');
    const locationSelect = document.querySelector('select[name="locations"]');
    const typeSelect = document.querySelector('select[name="event_type"]');
    let selectedLocationPrinted = false;
    let selectedEventTypePrinted = false;

    if(locationSelectWrapper){
        filterSettings.locations.length > 0 || selectedLocation !== '' ? locationSelectWrapper.classList.add('custom-select--active') : locationSelectWrapper.classList.remove('custom-select--active')
    }

    if(typeSelectWrapper){
        filterSettings.eventTypes.length > 0 || selectedEventType !== '' ? typeSelectWrapper.classList.add('custom-select--active') : typeSelectWrapper.classList.remove('custom-select--active')
    }
    
    if( locationSelect ){
        locationSelect.innerHTML = `
        <option value="" disabled="" selected="">Location</option>
        ${filterSettings.locations.map((location, i) => {
            if(selectedLocation == location.value){
                selectedLocationPrinted = true;
            }
            return `<option value="${location.value}" ${ selectedLocation == location.value ? `selected` : ``}>${location.label}</option>`
        }).join('')} 
        ${ !selectedLocationPrinted && selectedLocation !== `` ? `<option value="${selectedLocation}" selected>${allEventLocations[selectedLocation]}</option>` : ``}
        <option value="">All Locations</option>
        `;
    }

    if( typeSelect ){
        typeSelect.innerHTML = `
        <option value="" disabled="" selected="">Event Type</option>
        ${filterSettings.eventTypes.map((type, i) => {
            if(selectedEventType == type.value){
                selectedEventTypePrinted = true;
            }
            return `<option value="${type.value}" ${ selectedEventType == type.value ? `selected` : ``}>${type.label}</option>`
        }).join('')} 
        ${ !selectedEventTypePrinted && selectedEventType !== `` ? `<option value="${selectedEventType}" selected>${allEventTypes.find(type=>type.slug == selectedEventType).name}</option>` : ``}
        <option value="">All Event Types</option>
        `;
    }

    if( locationSelect || typeSelect){
        initCustomSelects();
    }  
    // console.log(`selected - location:${selectedLocation} | event type:${selectedEventType}`)
    // console.log(`setFilterOptions: ${JSON.stringify(getFilterSettings())}`);
}

function setSectionUrlParameters(section) {

    let urlParameterGroups = [];

    // add year
    urlParameterGroups.push('year=' + section.dataset.year);
    urlParameterGroups.push('month=' + section.dataset.month);

    // add location
    if(selectedLocation !== ''){
        urlParameterGroups.push('location=' + selectedLocation);
    }

    // add event type
    if(selectedEventType !== ''){
        urlParameterGroups.push('event-type=' + selectedEventType);
    }
    
    // concatenate all parameter groups
    const finalUrlParameters = urlParameterGroups.length > 0 ? '?' + urlParameterGroups.join('&') : '';

    if (finalUrlParameters != '') {
        history.pushState({ page: 'brain-health-library' }, "Sorting and filtering", finalUrlParameters);
    } else {
        history.replaceState({}, '', location.pathname);
    }

}


function selectUpdated(id){

    // get updated select
    const updatedSelect = document.getElementById(id);

    // update corresponding variables
    if(id.includes('location-select')){
        selectedLocation = updatedSelect.value;   
    }

    if(id.includes('event-type-select')){
        selectedEventType = updatedSelect.value;
    }
    
    // find the selection and set url paramenets
    eventFiltersSections.forEach((section)=>{
        if( id.includes(section.dataset.id) ){
            updateEventsList(section);
        }
    });

    setFilterOptions();

}


function printEvents(){
    // get list and heading elements and update their html
    eventListSection = document.querySelector('[data-event-list]');
    const eventList = document.querySelector('[data-event-list-items]');
    const eventListHeading = document.querySelector('[data-event-list-heading]');
    const eventListFeatured = document.querySelector('[data-event-list-featured]');
    
    if(eventList && eventListHeading && eventListFeatured){
        // add cards html to DOM
        eventList.innerHTML = getEventsHtml();
        // add add html to dom
        eventList.appendChild(getAdHmtl());
        // add featured event
        eventListFeatured.innerHTML = getFeaturedEventsHtml();
        // event list heading
        const eventListHeadingText = matchingMonthIndex !== -1 ? `${monthNames[eventsInfo.months[matchingMonthIndex]['month']]} Events` : `No Events`;
        eventListHeading.innerHTML = eventListHeadingText;
    }
}

function getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
  }
  

function filterEvents(){
    // filter the events within the range of the start and end dates
    const startDate = `${selectedYear}${String(selectedMonth).padStart(2, '0')}01`;
    const endDate = `${selectedYear}${String(selectedMonth).padStart(2, '0')}31`;
    filteredEvents = events.filter(event => {
        // add date condition
        const eventDate = event.event_date;
        const dateCondition = eventDate >= startDate && eventDate <= endDate
        // add location condition
        const locationCondition = ( selectedLocation == '' || event.location.includes(eventLocations[selectedLocation]) );
        // add event type condition
        const eventTypeCondition = ( selectedEventType == '' || event.event_types.includes(selectedEventType) );
        // eval all conditions
        return dateCondition && locationCondition && eventTypeCondition;
    });
}

function getAdHmtl(){
    const bannerSpan = emptySlotsInGrid(listTotal);
    if(bannerSpan > 0){
        // get template
        const template = document.getElementById('event-list-banner');
        // clone it
        const templateCopy = template.content.cloneNode(true);
        // add class
        templateCopy.querySelector('.banner').classList.add('banner--span-'+bannerSpan);
        // return element
        return templateCopy;
    }
    return document.createDocumentFragment();
}

function emptySlotsInGrid(items) {
    const columns = 3;
    const fullRows = Math.ceil(items / columns) * columns;
    return fullRows - items;
}

function getEventsHtml(){
    // sort posts
    sortedEvents = orderby(filteredEvents, 'event_date', 'asc');
    featuredPost = sortedEvents.find( item =>{
        return item.event_is_featured;
    });
    listTotal = featuredPost ? sortedEvents.length - 1 : sortedEvents.length;
    // console.log(`${sortedEvents.length} Sorted Events | ${featuredPost ? '1' : '0'} Featured Post | List Total:${ listTotal }, adspace:${emptySlotsInGrid(listTotal)}`);
    return `
        ${ sortedEvents.length > 0 ? `
            ${sortedEvents.map((event, i) => {
                const eventDisplayDate = moment(event.event_date, 'YYYYMMDD').format('dddd, MMM. D');
                const eventisNotfeatured = typeof featuredPost == 'undefined' || ( featuredPost && event.id !== featuredPost.id ) ;
                if(eventisNotfeatured){
                    return `
                    <a href="${event.permalink}" class="card card--basic">
                        ${ event.image ? `
                        <picture class="card__image">
                            <img class="absolute-image" src="${event.image.sizes.thumbnail}" alt="" loading="lazy"/>
                        </picture> 
                        ` : ``}
                        <span class="card__date-location ">
                            ${ event.type_icon ? `<img src="${siteUrl}/wp-content/themes/nmajh/images/icons/event-icons-${event.type_icon}.png" alt=""/>` : ``}
                            <span>
                                <h4 class="card__date subhead--medium uppercase">${eventDisplayDate}</h4>
                                <h5 class="card__location headline-3 uppercase">${event.location.replaceAll(',',', ')}</h5>
                            </span>
                        </span>
                        <span class="card__content">
                            ${ event.sponsor ? `<h4 class="card__sponsor headline-3 uppercase">${event.sponsor}</h4>` : `` }
                            <h3 class="card__title subhead">${event.title}</h3>
                            <span class="link">RSVP&#8702</span>
                        </span>
                    </a>
                    `;
                } else {
                    return '';
                }
            }).join('')}              
        ` : `<p class="event-list__no-results">
                Sorry! No results for
                ${selectedLocation !== '' ? `'${allEventLocations[selectedLocation]}'` : ``} 
                ${ selectedLocation !== '' && selectedEventType !== '' ? `and` : `` } 
                ${selectedEventType !== '' ? `'${allEventTypes.find(type=>type.slug == selectedEventType).name}'` : ``} events found.
            </p>
            `}
    `;
}

function getFeaturedEventsHtml(){
    
    const event = featuredPost;
    if(event){
        const eventDisplayDate = moment(event.event_date, 'YYYYMMDD').format('dddd, MMM. D');
        const eventisNotfeatured = typeof featuredPost == 'undefined' || ( featuredPost && event.id !== featuredPost.id ) ;
        return `
        <a href="${event.permalink}" class="card card--featured block--mobile-fullwidth">

            ${ event.image ? `
            <div class="card__image card__image--${event.image_sizing}">
                ${ event.image_sizing == 'contain' ? `<img class="card__image--main absolute-image" src="${event.image.sizes.thumbnail}" alt="" loading="lazy"/>` : ``}    
                <img class="absolute-image ${event.image_sizing == 'contain' ? `card__image--bg` : ``}" src="${event.image.sizes.thumbnail}" alt="" loading="lazy"/>
            </div> 
            ` : ``}
    
            <span class="card__date-location ">
                ${ event.type_icon ? `<img src="${siteUrl}/wp-content/themes/nmajh/images/icons/event-icons-${event.type_icon}.png" alt=""/>` : ``}
                <span>
                    <h4 class="card__date subhead--medium uppercase">${eventDisplayDate}</h4>
                    <h5 class="card__location headline-3 uppercase">${event.location}</h5>
                </span>
            </span>
            
            <span class="card__content">
                ${ event.sponsor ? `<h4 class="card__sponsor headline-3 uppercase">${event.sponsor}</h4>` : `` }
                <h3 class="card__title headline-2">${event.title}</h3>
                ${event.excerpt ? `<div class="card__excerpt body-1">${event.excerpt}</div>` : `` }

                ${event.location ? `
                    <h4 class="card__location subheading uppercase">
                    ${ event.type_icon ? `<img src="${siteUrl}/wp-content/themes/nmajh/images/icons/event-icons-${event.type_icon}.png" alt=""/>` : ``}
                    ${event.location}
                    </h4>` : ``}

                <span class="cta" ${ event.type_icon ? `style="background-color:${iconColors[event.type_icon]};"` : `` }>RSVP</span>
            </span>
        
        </a>
        `;
    } else {
        return '';
    }
    
}

/*
'.( $location || $bottom_heading ? '<h2 class="event-hero__bottom-heading">'.($type_icon ? '<img src="'.get_stylesheet_directory_uri().'/images/icons/event-icons-'.$type_icon.'.png"/>' : '').( $bottom_heading ? $bottom_heading : getEventLocations()[$location] ).'</h2>' : '').'
*/

export {
    selectUpdated
}